export default "__VITE_ASSET__CrsQPjmf__"